import styled from 'styled-components';
import { Colors } from '@blueprintjs/core';

export const SideBarButton = styled.div.attrs(props => ({
    width:props.width || 32,
    height:props.height || 32,
    borderRadius:props.borderRadius || 4,
    zIndex:props.zIndex || 550,
    darkMode: props.darkMode || false,
    darkBgColor: Colors.LIGHT_GRAY5,
    lightBgColor: Colors.GRAY5,
}))`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index:${props => props.zIndex};
    width:${props => `${props.width}px`};
    height:${props => `${props.height}px`};
    border-radius:${props => `${props.borderRadius}px`};
    background-color: ${props => props.darkMode ? props.darkBgColor : props.lightBgColor};
    transition: all 0.2s ease-in-out ;
    opacity: 0.6;
    cursor: pointer;
    &:hover {
        transition: all 0.2s ease-in-out;
        opacity:0.9;
    }
    &:hover span {
        visibility: visible;
    }
`;